import { __extends } from "tslib";
import { Container } from "../../core/render/Container";
/**
 * Base class for flow chart nodes.
 */
var FlowNode = /** @class */ (function (_super) {
    __extends(FlowNode, _super);
    function FlowNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Related series.
         */
        Object.defineProperty(_this, "series", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(FlowNode, "className", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FlowNode"
    });
    Object.defineProperty(FlowNode, "classNames", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: Container.classNames.concat([FlowNode.className])
    });
    return FlowNode;
}(Container));
export { FlowNode };
//# sourceMappingURL=FlowNode.js.map